const ancors = (ancorSelector, contentSelector) => {
    const ancorLink     = document.querySelector(ancorSelector),
          contentBlock  = document.querySelector(contentSelector);
    
    try {
        ancorLink.addEventListener('click', ()=>{
            
            contentBlock.scrollIntoView({block: "center", behavior: "smooth"});

        });
    } catch(e){}
};

export default ancors;